module.exports = __webpack_public_path__ + "img/content3-1.924a7db2.webp";